module.exports = __webpack_public_path__ + "img/icon_link.931ed0ec.png";